<template>
  <div class="text-editor">
    <vue-editor
      :value="value"
      @input="onEditorChange"
      :editor-toolbar="editorOptions.toolbar"
    />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'TextEditor',
  components: {
    VueEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorOptions: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'color': [] }, { 'background': [] }],
          ['clean']
        ]
      }
    }
  },
  methods: {
    onEditorChange(content) {
      this.$emit('input', content)
    }
  }
}
</script>

<style scoped>
.text-editor {
  border-radius: 4px;
  overflow: hidden;
}

:deep(.ql-editor) {
  min-height: 200px;
}

:deep(.ql-toolbar) {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background: #f8f9fa;
}

:deep(.ql-container) {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style> 